import { STATUS_DEFS } from '../roleTaxonomy';
import type { UserStatus } from '../roleTaxonomy';

interface UserStatusPillProps {
  status: UserStatus;
  /** Overrides the status's own label while keeping its colours. */
  label?: string;
}

/** Small status pill: Active / Invited / Inactive / Imported. */
export default function UserStatusPill({ status, label }: UserStatusPillProps) {
  const def = STATUS_DEFS[status];
  if (!def) return null;
  return (
    <span
      className={`inline-flex items-center gap-1.5 h-5 px-2 rounded-full text-[10.5px] font-semibold tracking-[.02em] ${def.className}`}
    >
      <i className={`w-[5px] h-[5px] rounded-full ${def.dot}`} />
      {label ?? def.label}
    </span>
  );
}
